import './App.css';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";

import Wrapper from './components/Wrapper';
import { lazy, createContext, useEffect } from 'react';
import { useTranslator } from './components/Translator'

const HomePage = lazy(() => import('./pages/HomePage'));
const PrayerPage = lazy(() => import('./pages/prayerPage/PrayerPage'));
const IAmNew = lazy(() => import('./pages/I_Am_New/I_Am_New'));
const Article = lazy(() => import('./pages/Articles/Article'));
const Articles = lazy(() => import('./pages/Articles/Articles'));
const UnderConstruction = lazy(() => import('./pages/UnderConstruction'));
const Gallery = lazy(() => import('./pages/Gallery'));
const Give = lazy(() => import('./pages/Give'));

export const TranslateContext = createContext([])

function App() {
  let [curLang, setCurLang, languages, translate] = useTranslator(window.localStorage.HBFLanguage)
  
  useEffect(() => {
    let reg = new RegExp(['\\/',curLang,'.*'].join(''), 'g')
    if(window.localStorage.HBFLanguage) {
      // setCurLang(window.localStorage.HBFLanguage)
    }
    if (!window.location.pathname.match(reg)) {
      window.location.pathname = `/${curLang}` + window.location.pathname
    }
  }, [curLang, setCurLang])
  return (
    <TranslateContext.Provider value={[curLang, setCurLang, languages, translate]}>
      <BrowserRouter basename={`/${curLang}`}>
        <Routes>
          <Route exact path="/" element={<Wrapper><HomePage /></Wrapper>}></Route>
          <Route path='/prayer' element={<Wrapper><PrayerPage /></Wrapper>}></Route>
          <Route path='/i-am-new' element={<Wrapper><IAmNew /></Wrapper>}></Route>
          <Route path='/article/:slug' element={<Wrapper><Article /></Wrapper>}></Route>
          <Route path='/articles' element={<Wrapper><Articles /></Wrapper>}></Route>
          <Route path='/ministries/:slug' element={<Wrapper><Article /></Wrapper>}></Route>
          <Route path='/gallery' element={<Wrapper><Gallery /></Wrapper>}></Route>
          <Route path='/give' element={<Wrapper><Give /></Wrapper>}></Route>
          <Route path='/underConstruction' element={<Wrapper><UnderConstruction /></Wrapper>}></Route>
          <Route path='*' element={<Wrapper><UnderConstruction /></Wrapper>}></Route>
          {/* <Route path='/load' element={<Wrapper><Loader /></Wrapper>}></Route> */}
          {/* <Route path='/ministries' element={<Wrapper><Ministries /></Wrapper>}></Route> */}
        </Routes>
      </BrowserRouter>
    </TranslateContext.Provider>
  );
}

export default App;
